import { type ReactNode } from "react"

interface ExpertVerdictCardProps {
  /** Card heading (defaults to "Fridge.com Expert Verdict") */
  title?: string
  /** Verdict content — string or rich ReactNode */
  children: ReactNode
  /** Additional classes on the wrapper */
  className?: string
}

export function ExpertVerdictCard({
  title = "Fridge.com Expert Verdict",
  children,
  className = "",
}: ExpertVerdictCardProps) {
  return (
    <div className={`p-6 bg-[#ff9951]/[0.06] rounded-lg ${className}`}>
      <h3 className="text-base font-bold text-gray-900 mb-3">{title}</h3>
      <div className="text-sm text-gray-600 leading-relaxed">{children}</div>
    </div>
  )
}
